export default __webpack_public_path__ + "static/media/ecd8a798484335bb80f2a3ba77fcf047.gif";